import styled from "@emotion/styled";
import bg from "../../assets/bg.png";
export const InfoAvantiCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1200px;
  height: 183px;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 2px solid #008247;
  position: relative;
  overflow: hidden;
  margin: 70px 0px;

  @media (max-width: 768px) {
    margin: 50px 0 0 0;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${bg});
    background-size: cover;
    background-position: center;
    opacity: 0.4;
    z-index: 0;
  }

  .isAvantiContainer {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center !important;
    gap: 24px;
    z-index: 1;

    .avantiText {
      font-family: Roboto Condensed;
      font-weight: 600;
      font-size: 32px;
      line-height: 37.5px;
      letter-spacing: 0%;
      text-align: center;
      color: #ffffff;
      text-transform: uppercase;
    }

    @media (max-width: 1100px) {
      flex-direction: column;
      justify-content: center;
      gap: 64px;
      align-items: space-between;
      height: 310px;
    }
  }

  .infoUserContainer {
    display: flex;
    width: 430px;
    height: 97px;
    flex-direction: row;
    left: 40px;
    padding: 16px 16px;
    align-items: center;
    gap: 32px;
    border-radius: 8px;
    background: #ffffff1a;
    position: relative;
    z-index: 1;

    .img {
      width: 101px;
      height: 72px;
      transform: rotate(-4.82deg);
      @media (max-width: 1100px) {
        width: 78px;
        height: 55px;
      }
    }

    .infoUser {
      display: flex;
      padding: 0 16px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 4px;

      .planName {
        font-family: Roboto;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        color: #e7c394;
      }

      .userName {
        font-family: Roboto;
        font-weight: 800;
        font-size: 21px;
        line-height: 24.61px;
        letter-spacing: 2%;
        text-transform: uppercase;
        color: #ffffff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;

        @media (max-width: 1100px) {
          max-width: 150px;
        }
      }

      @media (max-width: 1100px) {
        padding: 0;
      }
    }

    @media (max-width: 1100px) {
      width: auto;
      left: 0;
    
    }
  }

  @media (max-width: 1100px) {
    flex-direction: column;
    height: auto;
    width: 336px;
    gap: 16px;
    left: 0;
    padding: 16px 16px;
  }

  .luckInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    z-index: 1;
    width: 100%;

    .luckyText {
      font-family: Roboto Condensed;
      font-weight: 600;
      font-size: 18px;
      line-height: 21.09px;
      letter-spacing: 0%;
      text-transform: uppercase;
      color: #ffffff;
    }

    .totalLuckyNumbers {
      font-family: Roboto Condensed;
      font-weight: 800;
      font-size: 48px;
      line-height: 56.25px;
      letter-spacing: 0%;
      color: #dae753;
    }

    @media (max-width: 1100px) {
      flex-direction: column;
    }
  }

  .buttonMyNumbersContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 156px;
    height: 51px;
    margin-right: 40px;
    border-radius: 4px;
    gap: 10px;
    padding: 16px 24px;
    background: #dae753;
    border: none;
    z-index: 1;
    cursor: pointer;

    .buttonMyNumbersText {
      font-family: Roboto Condensed;
      font-weight: 700;
      font-size: 16px;
      line-height: 18.75px;
      letter-spacing: 0%;
      text-transform: uppercase;
      color: #006437;
      white-space: nowrap;
    }

    @media (max-width: 1100px) {
      margin-right: 0;
      width: 100%;
      min-width: 200px;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    width: 100%;
    max-width: 366px;
    height: 374px;
    padding: 16px 32px;
  }
`;